import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import ZingBot from './components/feature/ZingBot';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Suspense fallback={
        <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#00f0ff]/20 to-[#a855f7]/20 rounded-full mb-4 animate-pulse">
              <i className="ri-loader-4-line text-4xl text-[#00f0ff] animate-spin"></i>
            </div>
            <p className="text-white text-xl">Loading...</p>
          </div>
        </div>
      }>
        <AppRoutes />
        <ZingBot />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
